import { action, observable } from 'mobx'
import { NotiPermissionResquest } from '../requests/NotiPermissionResquest'

class NotiPermissionStore {
  @observable content = []

  @action getNotiPermissionContent = () => {
    return new Promise((resolve, reject) => {
      NotiPermissionResquest.getNotiPermissionContent()
        .then(response => {
          this.content = response.data?.split(',')
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action updateNotiPermissionContent = content => {
    return new Promise((resolve, reject) => {
      NotiPermissionResquest.updateNotiPermissionContent(content)
        .then(response => {
          this.content = response.data?.split(',')
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

export default new NotiPermissionStore()
